import { render, staticRenderFns } from "./RodeoPieChart.vue?vue&type=template&id=dd9bb99a&scoped=true&"
import script from "./RodeoPieChart.vue?vue&type=script&lang=ts&"
export * from "./RodeoPieChart.vue?vue&type=script&lang=ts&"
import style0 from "./RodeoPieChart.vue?vue&type=style&index=0&id=dd9bb99a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9bb99a",
  null
  
)

export default component.exports